import React from 'react';
import './GlobalFooter.css';

const GlobalFooter: React.FC = () => {
  return (
    <footer className="global-footer">
      <div className="footer-content">
        <p className="copyright-text">Copyright © 2025 retinARC. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default GlobalFooter;
